var render = function render(){
  var _vm$value, _vm$value2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.value.side == _vm.EMPLOYMENT_FIELD_SIDES.DOCUMENT.value ? [_vm._v(" " + _vm._s((_vm$value = _vm.value) === null || _vm$value === void 0 ? void 0 : _vm$value.data) + " ")] : [false ? void 0 : _vm.mode == 'done' ? [_vm._v(" " + _vm._s((_vm$value2 = _vm.value) === null || _vm$value2 === void 0 ? void 0 : _vm$value2.data) + " ")] : _vm.mode == 'sign' ? [_c('node-edit', _vm._g(_vm._b({
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var save = _ref.save;
        return [_c('v-text-field', {
          attrs: {
            "clearable": "",
            "autofocus": ""
          },
          on: {
            "keydown": function ($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
              $event.preventDefault();
              return save.apply(null, arguments);
            }
          },
          model: {
            value: _vm.form.data,
            callback: function ($$v) {
              _vm.$set(_vm.form, "data", $$v);
            },
            expression: "form.data"
          }
        })];
      }
    }])
  }, 'node-edit', {
    value: _vm.value,
    width: 320
  }, false), {
    sync: _vm.sync,
    emit: _vm.emit
  }))] : [_c('span', {
    staticStyle: {
      "opacity": "0.5",
      "word-break": "auto-phrase"
    }
  }, [_vm._v(" " + _vm._s(_vm.value.term) + " ")])]]], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }